//#region Asset Imports

import './item.scss'
import * as TEMPLATE from './item.tpl.html'

//#endregion

export class ItemDirective implements ng.IDirective {

    scope = {
        item: '=',
        model: '=',
        isEditMode: '=',
        contentWidth: '=',
        disableRefresh: '=',
        backgroundColor: '=?'
    }

    restrict = 'E'
    template = TEMPLATE
    transclude = true
    replace = true
}